<template>
  <div class="mx-md-3 my-md-3">
    <h4>Velg laveste nivå for varsling</h4>
    <p>
      Her kan du velge laveste ønskede &shy;nivå du vil motta varsel om.
      Klikk på ønsket nivå for å endre.
      Nivåene i rammen under er de du vil motta varsel om.
    </p>
    <div class="mt-4 mx-3">
      <div class="row pt-3 pb-2 py-2 selectable" :class="level5Class" v-on:click="newLevel(5)">
        <div class="col-2 col-md-1 radiocolumn">
          <input type="radio" id="level5" value="5" v-model="minLevel" />
        </div>
        <div class="col-2 pt-1 px-2">
          <span class="level level-5 d-sm-none">5</span>
          <span class="level level-5 d-none d-sm-block">5</span>
        </div>
        <div class="col-8 col-md-9">
          <strong>Meget stor snøskredfare</strong>
          <br />
          <p class="select-text">
            Faregrad 5 er en ekstrem hendelse og forekommer sjeldent.
            Bebyggelse og annen infrastruktur kan være truet.
            Vegstrekninger kan bli stengt.
            <transition name="fade" mode="out-in">
              <span v-show="!showMore5" class="read-more">
                ...
                <br />
                <a class="read-more" href="#" @click.prevent.stop="showMore5=true">Vis mer</a>
              </span>
            </transition>
            <transition name="fade" mode="in-out">
              <span v-show="showMore5">
                Vær obs på at skredene i slike tilfeller kan få lengre rekkevidde enn hva som er registrert tidligere. Mange store, også svært store, naturlig utløste skred forventes, selv i moderat bratt terreng.
                Beredskapsaktører bør følge situasjonen tett og løpende vurdere utsatt infrastruktur opp mot skredproblem og aktsomhetskart, eller faresonekart der disse foreligger.
                <br />
                <a class="read-more" href="#" @click.prevent.stop="showMore5=false">Vis mindre</a>
              </span>
            </transition>
          </p>
        </div>
      </div>
      <div class="row py-2 selectable" :class="level4Class" v-on:click="newLevel(4)">
        <div class="col-2 col-md-1 radiocolumn">
          <input type="radio" id="level4" value="4" v-model="minLevel" />
        </div>
        <div class="col-2 pt-1 px-2">
          <span class="level level-4 d-sm-none">4</span>
          <span class="level level-4 d-none d-sm-block">4</span>
        </div>
        <div class="col-8 col-md-9">
          <strong>Stor snøskredfare</strong>
          <br />
          <p class="select-text">
            I enkelte tilfeller kan skred nå bebyggelse og annen infrastruktur.
            Utsatte vegstrekninger kan bli stengt.
            <span
              v-show="!showMore4"
              class="read-more"
            >
              ...
              <br />
              <transition name="fade">
                <a class="read-more" href="#" @click.prevent.stop="showMore4=true">Vis mer</a>
              </transition>
            </span>
            <transition name="fade" mode="in-out">
              <span v-show="showMore4">
                Under spesielle forhold forventes det mange middels store og noen store naturlig utløste skred. Snøskredfare 4-stor meldes gjennomsnittlig tre-fire ganger i året for et varslingsområde.
                Beredskapsaktører bør ha økt fokus og vurdere utsatt infrastruktur opp mot skredproblem og aktsomhetskart, eller faresonekart der disse foreligger.
                <br />
                <a class="read-more" href="#" @click.prevent.stop="showMore4=false">Vis mindre</a>
              </span>
            </transition>
          </p>
        </div>
      </div>
      <div class="row py-2 selectable" :class="level3Class" v-on:click="newLevel(3)">
        <div class="col-2 col-md-1 radiocolumn">
          <input type="radio" id="level3" value="3" v-model="minLevel" />
        </div>
        <div class="col-2 pt-1 px-2">
          <span class="level level-3 d-sm-none">3</span>
          <span class="level level-3 d-none d-sm-block">3</span>
        </div>
        <div class="col-8 col-md-9">
          <strong>Betydelig snøskredfare</strong>
          <br />
          <p class="select-text">
            Snøskred kan true vei og bebyggelse kun i spesielle tilfeller.
            <span
              v-show="!showMore3"
              class="read-more"
            >
              ...
              <br />
              <transition name="fade">
                <a class="read-more" href="#" @click.prevent.stop="showMore3=true">Vis mer</a>
              </transition>
            </span>
            <transition name="fade" mode="in-out">
              <span v-show="showMore3">
                Hvis det er mulighet for større naturlig utløste skred vil dette stå uthevet i snøskredvarselet.
                Beredskapsaktører bør i slike tilfeller følge med på værforhold og vurdere utsatt infrastruktur opp mot skredproblem og aktsomhetskart, eller faresonekart der disse foreligger.
                <br />
                <a class="read-more" href="#" @click.prevent.stop="showMore3=false">Vis mindre</a>
              </span>
            </transition>
          </p>
        </div>
      </div>
      <div class="row py-2 selectable" :class="level2Class" v-on:click="newLevel(2)">
        <div class="col-2 col-md-1 radiocolumn">
          <input type="radio" id="level2" value="2" v-model="minLevel" />
        </div>
        <div class="col-2 pt-1 px-2">
          <span class="level level-2 d-sm-none">2</span>
          <span class="level level-2 d-none d-sm-block">2</span>
        </div>
        <div class="col-8 col-md-9">
          <strong>Moderat snøskredfare</strong>
          <small>(Anbefalt nivå)</small>
          <br />
          <p class="select-text">Snøskred som kan true vei eller bebyggelse er lite sannsynlig.</p>
        </div>
      </div>
      <div class="row py-2">
        <div class="col-2 col-md-1 radiocolumn"></div>
        <div class="col-2 pt-1 px-2">
          <span class="level level-1 d-sm-none">1</span>
          <span class="level level-1 d-none d-sm-block">1</span>
        </div>
        <div class="col-8 col-md-9">
          <strong>Liten snøskredfare</strong>
          <br />
          <p class="select-text">Det sendes ikke varsler for dette nivået</p>
        </div>
      </div>
      <div class="row py-2 mt-4">
        <div class="col-12 pl-0">
          <button
            type="button"
            class="btn btn-nve btn-primary mr-4"
            @click="selectLevel"
          >Ok, tilbake til varsel</button>
          <a href="#" @click.prevent="cancel">Avbryt</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AvalancheLevelSelector",
  props: {
    subscriptionType: {},
    selectedLevel: {
      type: Number
    }
  },
  data() {
    return {
      minLevel: "2",
      showMore3: false,
      showMore4: false,
      showMore5: false
    };
  },
  created() {
    this.reset();
  },
  methods: {
    reset() {
      this.minLevel = this.selectedLevel.toString();
    },
    newLevel(level) {
      this.minLevel = level.toString();
    },
    selectLevel() {
      this.$emit("levelSelected", parseInt(this.minLevel, 10));
    },
    cancel() {
      this.$emit("levelSelected", -1);
      this.reset();
    }
  },
  computed: {
    level5Class() {
      if (this.minLevel === "5") {
        return "first-selected last-selected";
      }
      return "first-selected";
    },
    level4Class() {
      if (this.minLevel === "5") {
        return "";
      }
      if (this.minLevel === "4") {
        return "last-selected";
      }
      return "selected";
    },
    level3Class() {
      if (this.minLevel === "3") {
        return "last-selected";
      }
      if (this.minLevel === "2") {
        return "selected";
      }
      return "";
    },
    level2Class() {
      if (this.minLevel === "2") {
        return "last-selected";
      }
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/levelselector.scss";

a.read-more {
  margin-top: 4px;
  font-size: 14px;
  font-style: italic;
  opacity: 0.8;
}
</style>

